export const SET_STATE_SIDEBAR = "SETSTATESIDEBAR";

export function setStateSidebar(payload) {
  return {
    type: SET_STATE_SIDEBAR,
    payload,
  };
}
